import { SideMenuIcons } from "./side-menu-icons";

export const SideBarNotificationNames = {
  [SideMenuIcons.Default]: 'Lobby',
  [SideMenuIcons.Promo]: 'Promo',
  [SideMenuIcons.Wheel]: 'Boosted Jackpot',
  [SideMenuIcons.Tournament]: 'Tournament',
  [SideMenuIcons.Jackpot]: 'Jackpot',
  [SideMenuIcons.Freespin]: 'Free Spin',
  [SideMenuIcons.Win]: 'Win',
  [SideMenuIcons.ActivePromos]: 'Active Promos'
}